module.exports = __webpack_public_path__ + "static/img/avatar-default-white.60c89b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar-default-white.png
// module id = qlwa
// module chunks = 2